import { jsx } from "react/jsx-runtime";
import { MinusIcon, SuccessIcon } from "@dion-web/ui-icons";
import MCheckbox from "@mui/material/Checkbox";
import styled from "@mui/material/styles/styled";
import { renderToString } from "react-dom/server";
var ECheckboxSize = /* @__PURE__ */ ((ECheckboxSize2) => {
  ECheckboxSize2["S"] = "s";
  ECheckboxSize2["M"] = "m";
  return ECheckboxSize2;
})(ECheckboxSize || {});
const CHECKBOX_SIZE_M = 20;
const CHECKBOX_SIZE_S = 16;
const CHECKBOX_BORDER_RADIUS = 4;
const DOUBLE_QUOTATION_MARK_REGEX = /"/gu;
const SINGLE_QUOTATION_MARK = "'";
const OPENING_TAG_REGEX = /</gu;
const CLOSING_TAG_REGEX = />/gu;
const OPENING_TAG_URL_ENCODING = "%3C";
const CLOSING_TAG_URL_ENCODING = "%3E";
const BpIcon = styled("span")(({ theme, checkboxSize, disabled }) => {
  const palette = theme.palette;
  const borderColor = palette.dionCommon.additional;
  const hoverBorderColor = palette.brand.main;
  const disabledBgColor = palette.dionCommon.disable;
  return {
    borderRadius: CHECKBOX_BORDER_RADIUS,
    width: `${checkboxSize}px`,
    height: `${checkboxSize}px`,
    boxShadow: `0 0 0 1px ${borderColor}`,
    backgroundColor: theme.palette.brand.transparent,
    ...!disabled && {
      "input:hover ~ &": {
        boxShadow: `0 0 0 1px ${hoverBorderColor}`
      }
    },
    "input:disabled ~ &": {
      backgroundColor: disabledBgColor
    }
  };
});
const getSvgString = (SuccessComponent) => {
  const svgString = renderToString(/* @__PURE__ */ jsx(SuccessComponent, { fill: "white" }));
  const replacedSvgString = svgString.replace(DOUBLE_QUOTATION_MARK_REGEX, SINGLE_QUOTATION_MARK);
  return replacedSvgString.replace(OPENING_TAG_REGEX, OPENING_TAG_URL_ENCODING).replace(CLOSING_TAG_REGEX, CLOSING_TAG_URL_ENCODING);
};
const successIcon = getSvgString(SuccessIcon);
const minusIcon = getSvgString(MinusIcon);
const BpCheckedIcon = styled(BpIcon)(({ theme, checkboxSize, disabled, icon }) => {
  const palette = theme.palette;
  const checkedBgColor = disabled ? palette.dionCommon.additional : palette.brand.main;
  const hoverBgColor = palette.onBrand.accent;
  return {
    backgroundColor: checkedBgColor,
    boxShadow: `0 0 0 1px ${checkedBgColor}`,
    "&::before": {
      display: "block",
      width: `${checkboxSize}px`,
      height: `${checkboxSize}px`,
      backgroundImage: `url("data:image/svg+xml;charset=utf-8,${icon}")`,
      backgroundRepeat: "repeat",
      backgroundSize: "cover",
      content: '""'
    },
    ...!disabled && {
      "input:hover ~ &": {
        backgroundColor: hoverBgColor,
        boxShadow: `0 0 0 1px ${hoverBgColor}`
      }
    }
  };
});
const CustomCheckbox = styled(MCheckbox)(() => {
  return {
    padding: "2px"
  };
});
const Checkbox = (props) => {
  const { size, disabled } = props;
  const checkboxSize = size === "m" /* M */ ? CHECKBOX_SIZE_M : CHECKBOX_SIZE_S;
  return /* @__PURE__ */ jsx(
    CustomCheckbox,
    {
      disableRipple: true,
      disabled,
      checkedIcon: /* @__PURE__ */ jsx(BpCheckedIcon, { checkboxSize, disabled, icon: successIcon }),
      indeterminateIcon: /* @__PURE__ */ jsx(BpCheckedIcon, { checkboxSize, disabled, icon: minusIcon }),
      icon: /* @__PURE__ */ jsx(BpIcon, { checkboxSize, disabled }),
      inputProps: { "aria-label": "Checkbox demo" },
      ...props
    }
  );
};
var Checkbox_default = Checkbox;
export {
  ECheckboxSize,
  Checkbox_default as default
};
